import { StationEvent } from '../../../services/models/stationEvent';
import { EVENT_TYPE_LABELS, EVENT_TYPE_COLORS, STATUS_BADGE, formatDateTime, getTooltipLines, getRecoveryBadge } from './eventConstants';
import StatusBadge from './StatusBadge';

export { EVENT_TYPE_LABELS };

const EventRow: React.FC<{ event: StationEvent }> = ({ event }) => {
  // Recovery events carry severity in `status`, so give them a dedicated badge +
  // tooltip rather than the action-lifecycle copy (see getRecoveryBadge).
  const recovery = event.type === 'recovery' ? getRecoveryBadge(event) : null;
  const baseStatus = STATUS_BADGE[event.status] ?? STATUS_BADGE.ok;
  const statusStyle = recovery ?? baseStatus;
  const dotColor = EVENT_TYPE_COLORS[event.type] ?? 'bg-neutral-40';
  const tooltipLines = recovery ? recovery.tooltipLines : getTooltipLines(event, baseStatus.tooltip);
  // A refused keypad attempt is recorded as code_used/error — label it as such.
  const typeLabel = event.type === 'code_used' && event.status === 'error'
    ? 'Code refusé'
    : (EVENT_TYPE_LABELS[event.type] ?? event.type);

  return (
    <div className="flex items-center px-5 py-2.5 border-b border-neutral-5 hover:bg-neutral-5 transition-colors">
      <span className="w-[130px] flex-shrink-0 typo-small text-neutral-60 whitespace-nowrap">
        {formatDateTime(event.createdAt)}
      </span>
      <div className="w-40 flex-shrink-0 flex items-center gap-2">
        <span className={`size-1.5 rounded-[3px] ${dotColor}`} />
        <span className="typo-small text-neutral">
          {typeLabel}
        </span>
      </div>
      <span className="w-[70px] flex-shrink-0 typo-small text-neutral !font-bold">
        {event.lock ? `Lock ${event.lock.position + 1}` : '—'}
      </span>
      <span className="flex-grow typo-small text-neutral-60 truncate pr-2">
        {event.details ?? '—'}
      </span>
      <span className="w-[70px] flex-shrink-0">
        <StatusBadge statusStyle={statusStyle} tooltipLines={tooltipLines} />
      </span>
    </div>
  );
};

export default EventRow;
